/* global Mustache */
/* global site */

(function () {
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
      thisArg = thisArg || window;
      for (var i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
      }
    };
  }

  function FoundationShadeFinderDialog(dialogElement, overlayElement) {
    this.dialogElement = dialogElement;
    this.overlayElement = overlayElement;
    this.closeDialog();
  }

  FoundationShadeFinderDialog.prototype.openDialog = function (hookDialogDOMEvents) {
    var Dialog = this;

    this.dialogElement.removeAttribute('aria-hidden');
    this.overlayElement.removeAttribute('aria-hidden');

    this.dialogElement.addEventListener('keydown', function (event) {
      Dialog.handleDialogKeys(event);
    });

    this.overlayElement.addEventListener('click', function () {
      Dialog.closeDialog();
    });

    hookDialogDOMEvents();
  };

  FoundationShadeFinderDialog.prototype.closeDialog = function () {
    clearHoverOnFoundationListAndWheel();
    this.dialogElement.setAttribute('aria-hidden', true);
    this.overlayElement.setAttribute('aria-hidden', true);
  };

  FoundationShadeFinderDialog.prototype.closeDialogWithoutOverlay = function () {
    this.dialogElement.setAttribute('aria-hidden', true);
  };

  FoundationShadeFinderDialog.prototype.handleDialogKeys = function (event) {
    var Dialog = this;

    if (event.key === undefined) {
      event.key = event.keyCode === 27 ? 'Escape' : '';
    }

    switch (event.keyCode) {
      case 'Escape':
        Dialog.closeDialog();
        break;
      default:
        break;
    }
  };

  FoundationShadeFinderDialog.prototype.addEventListeners = function (
    openDialogSelector,
    closeDialogSelector
  ) {
    var Dialog = this;
    var openedDialogElements = document.querySelectorAll(openDialogSelector);
    var openedDialogIndex;

    for (
      openedDialogIndex = 0;
      openedDialogIndex < openedDialogElements.length;
      openedDialogIndex++
    ) {
      openedDialogElements[openedDialogIndex].addEventListener('click', function () {
        Dialog.openDialog();
      });
    }

    var closedDialogElements = document.querySelectorAll(closeDialogSelector);
    var closedDialogIndex;

    for (
      closedDialogIndex = 0;
      closedDialogIndex < closedDialogElements.length;
      closedDialogIndex++
    ) {
      closedDialogElements[closedDialogIndex].addEventListener('click', function () {
        Dialog.closeDialog();
      });
    }
  };

  var foundationProductSkusAdditionalData = [
    {
      sku: '6MNY39',
      skuBaseId: 95507,
      wheelImage: 'Clinique_Foundation_01_Emma_Bartlette_133_04_RGB.png',
      wheelHoverPathXs:
        'M97.6445 1.05576C103.523 0.860359 109.407 1.17877 115.229 2.00735L112.448 21.5542C107.763 20.8876 103.029 20.6314 98.3004 20.7886L97.6445 1.05576Z',
      wheelHoverPathXl:
        'M209.626 1.14256C222.283 0.684072 234.956 1.33201 247.501 3.07898L241.636 45.19C231.544 43.7845 221.348 43.2633 211.166 43.6321L209.626 1.14256Z',
      shadeMatches: ['KL3P02', 'KL3P04', 'KL3P18']
    },
    {
      sku: '6MNY40',
      skuBaseId: 95508,
      wheelImage: 'Clinique_Foundation_02_Chanel_082_03_RGB.png',
      wheelHoverPathXs:
        'M108.974 1.31523C114.837 1.77955 120.648 2.75509 126.341 4.23073L121.387 23.3429C116.807 22.1557 112.132 21.3709 107.415 20.9973L108.974 1.31523Z',
      wheelHoverPathXl:
        'M234.292 1.64921C246.92 2.62705 259.438 4.706 271.704 7.86234L261.108 49.0383C251.24 46.499 241.169 44.8264 231.01 44.0397L234.292 1.64921Z',
      shadeMatches: ['KL3P03', 'KL3P07', 'KL3P17']
    },
    {
      sku: '6MNY41',
      skuBaseId: 95509,
      wheelImage: 'Clinique_Foundation_03_Renata_Gubayva_132_04_RGB.png',
      wheelHoverPathXs:
        'M120.196 1.84089C125.97 2.95867 131.635 4.57867 137.127 6.68242L130.065 25.1199C125.647 23.4273 121.089 22.124 116.443 21.2248L120.196 1.84089Z',
      wheelHoverPathXl:
        'M258.464 3.89247C270.903 6.27787 283.109 9.74519 294.945 14.2549L279.806 53.9858C270.284 50.3576 260.464 47.5681 250.456 45.649L258.464 3.89247Z',
      shadeMatches: ['KL3P03', 'KL3P04', 'KL3P23']
    },
    {
      sku: '6MNY42',
      skuBaseId: 95510,
      wheelImage: 'Clinique_Foundation_04_Jacqueline_Cassidy_155_09_RGB.png',
      wheelHoverPathXs:
        'M131.176 4.6133C136.789 6.3705 142.237 8.6146 147.46 11.32L138.378 28.8509C134.176 26.6743 129.793 24.8689 125.277 23.4552L131.176 4.6133Z',
      wheelHoverPathXl:
        'M282.121 9.82149C294.214 13.5845 305.956 18.3966 317.212 24.2029L297.72 61.9891C288.664 57.3178 279.218 53.4464 269.489 50.419L282.121 9.82149Z',
      shadeMatches: ['KL3P03', 'KL3P07', 'KL3P18']
    },
    {
      sku: '6MNY43',
      skuBaseId: 95511,
      wheelImage: 'Clinique_Foundation_05_Nuri_121_08_RGB.png',
      wheelHoverPathXs:
        'M141.777 8.59762C147.158 10.9721 152.321 13.8121 157.208 17.0852L146.22 33.489C142.289 30.8558 138.135 28.571 133.806 26.6607L141.777 8.59762Z',
      wheelHoverPathXl:
        'M304.965 18.3617C316.561 23.4549 327.691 29.5513 338.226 36.5813L314.626 71.9478C306.15 66.292 297.197 61.3874 287.867 57.2898L304.965 18.3617Z',
      shadeMatches: ['KL3P03', 'KL3P05', 'KL3P23']
    },
    {
      sku: '6MNY24',
      skuBaseId: 31798,
      wheelImage: 'Clinique_Foundation_06a_Vanessa_Greca_020_07_RGB.png',
      wheelHoverPathXs:
        'M151.866 13.7437C156.947 16.7057 161.76 20.1059 166.249 23.9054L153.494 38.976C149.882 35.9193 146.01 33.1838 141.923 30.8008L151.866 13.7437Z',
      wheelHoverPathXl:
        'M326.71 29.4058C337.663 35.7652 348.04 43.0692 357.721 51.2345L330.311 83.7365C322.521 77.1674 314.173 71.2912 305.361 66.1749L326.71 29.4058Z',
      shadeMatches: ['KL3P03', 'KL3P07', 'KL3P23']
    },
    {
      sku: '6MNY01',
      skuBaseId: 14117,
      wheelImage: 'Clinique_Foundation_07_Dian_Griesel_081_08_RGB.png',
      wheelHoverPathXs:
        'M161.315 19.987C166.032 23.4992 170.434 27.4167 174.47 31.695L160.108 45.2429C156.861 41.801 153.32 38.6492 149.524 35.8236L161.315 19.987Z',
      wheelHoverPathXl:
        'M347.081 42.8148C357.254 50.3605 366.747 58.7803 375.454 67.9782L344.577 97.2071C337.572 89.8072 329.934 83.0334 321.751 76.9627L347.081 42.8148Z',
      shadeMatches: ['KL3P06', 'KL3P10', 'KL3P23']
    },
    {
      sku: '6MNY44',
      skuBaseId: 95512,
      wheelImage: 'Clinique_Foundation_08_Hsu_Chen_170_04_RGB.png',
      wheelHoverPathXs:
        'M170.006 27.2488C174.3 31.2671 178.236 35.6528 181.767 40.356L165.978 52.2108C163.137 48.427 159.971 44.8986 156.516 41.6659L170.006 27.2488Z',
      wheelHoverPathXl:
        'M365.824 58.4202C375.087 67.0573 383.578 76.487 391.201 86.6018L357.245 112.19C351.113 104.053 344.281 96.4662 336.829 89.5176L365.824 58.4202Z',
      shadeMatches: ['KL3P04', 'KL3P07', 'KL3P23']
    },
    {
      sku: '6MNY25',
      skuBaseId: 31799,
      wheelImage: 'Clinique_Foundation_09_Nane_Feist_084_10_RGB.png',
      wheelHoverPathXs:
        'M177.828 35.4379C181.646 39.9118 185.066 44.7105 188.049 49.7795L171.032 59.7922C168.633 55.7141 165.881 51.8534 162.81 48.2542L177.828 35.4379Z',
      wheelHoverPathXl:
        'M382.701 76.0258C390.939 85.6457 398.321 95.9668 404.763 106.871L368.157 128.497C362.974 119.724 357.035 111.421 350.407 103.682L382.701 76.0258Z',
      shadeMatches: ['KL3P03', 'KL3P04', 'KL3P18']
    },
    {
      sku: '6MNY14',
      skuBaseId: 14130,
      wheelImage: 'Clinique_Foundation_10_Mick_Szal_120_11_RGB.png',
      wheelHoverPathXs:
        'M184.685 44.4514C187.978 49.3245 190.839 54.4759 193.236 59.8469L175.205 67.8916C173.277 63.5706 170.976 59.4262 168.326 55.5057L184.685 44.4514Z',
      wheelHoverPathXl:
        'M397.501 95.4102C404.61 105.892 410.791 116.975 415.971 128.532L377.174 145.924C373.006 136.626 368.034 127.709 362.314 119.277L397.501 95.4102Z',
      shadeMatches: ['KL3P07', 'KL3P12', 'KL3P24']
    },
    {
      sku: '6MNY02',
      skuBaseId: 14118,
      wheelImage: 'Clinique_Foundation_11_Saida Valieua_157_08_RGB.png',
      wheelHoverPathXs:
        'M190.49 54.1759C193.217 59.387 195.483 64.8263 197.263 70.4319L178.445 76.4074C177.013 71.8977 175.19 67.5216 172.996 63.3292L190.49 54.1759Z',
      wheelHoverPathXl:
        'M410.038 116.33C415.929 127.541 420.83 139.246 424.684 151.311L384.183 164.25C381.082 154.544 377.14 145.127 372.4 136.107L410.038 116.33Z',
      shadeMatches: ['KL3P04', 'KL3P13', 'KL3P23']
    },
    {
      sku: '6MNY45',
      skuBaseId: 95513,
      wheelImage: 'Clinique_Foundation_12_Adda_Zmora_191_06_RGB.png',
      wheelHoverPathXs:
        'M195.17 64.4891C197.296 69.9727 198.939 75.6316 200.08 81.4011L180.712 85.2324C179.794 80.5907 178.472 76.038 176.761 71.6263L195.17 64.4891Z',
      wheelHoverPathXl:
        'M420.154 138.521C424.753 150.322 428.312 162.502 430.792 174.922L389.097 183.245C387.102 173.253 384.239 163.454 380.539 153.96L420.154 138.521Z',
      shadeMatches: ['KL3P01', 'KL3P07', 'KL3P28']
    },
    {
      sku: '6MNY03',
      skuBaseId: 14119,
      wheelImage: 'Clinique_Foundation_13_Jules_Mordovets_197_06_RGB.png',
      wheelHoverPathXs:
        'M198.665 75.2614C200.164 80.9485 201.163 86.7558 201.651 92.6168L181.976 94.2556C181.583 89.5403 180.779 84.8682 179.573 80.2928L198.665 75.2614Z',
      wheelHoverPathXl:
        'M427.722 161.706C430.971 173.947 433.144 186.449 434.218 199.069L391.853 202.672C390.99 192.519 389.241 182.461 386.627 172.613L427.722 161.706Z',
      shadeMatches: ['KL3P06', 'KL3P08', 'KL3P23']
    },
    {
      sku: '6MNY46',
      skuBaseId: 95514,
      wheelImage: 'Clinique_Foundation_14_Natalia_Costa_148_07_RGB.png',
      wheelHoverPathXs:
        'M200.933 86.3572C201.786 92.1765 202.128 98.0591 201.957 103.938L182.222 103.364C182.36 98.634 182.084 93.9013 181.398 89.2196L200.933 86.3572Z',
      wheelHoverPathXl:
        'M432.647 185.592C434.505 198.12 435.265 210.787 434.919 223.447L392.417 222.285C392.696 212.099 392.084 201.909 390.589 191.829L432.647 185.592Z',
      shadeMatches: ['KL3P06', 'KL3P07', 'KL3P23']
    },
    {
      sku: '6MNY47',
      skuBaseId: 95515,
      wheelImage: 'Clinique_Foundation_15_Alle_Johnson_017_08_RGB.png',
      wheelHoverPathXs:
        'M201.944 97.6373C202.14 103.515 201.822 109.399 200.994 115.222L181.447 112.442C182.113 107.757 182.369 103.024 182.211 98.2946L201.944 97.6373Z',
      wheelHoverPathXl:
        'M434.866 209.879C435.31 222.537 434.648 235.209 432.886 247.751L390.782 241.837C392.199 231.747 392.732 221.552 392.375 211.369L434.866 209.879Z',
      shadeMatches: ['KL3P01', 'KL3P04', 'KL3P28']
    },
    {
      sku: '6MNY48',
      skuBaseId: 95516,
      wheelImage: 'Clinique_Foundation_16_Leaf_Zhang_090_09_RGB.png',
      wheelHoverPathXs:
        'M201.686 108.96C201.222 114.823 200.248 120.634 198.773 126.327L179.66 121.376C180.846 116.796 181.631 112.121 182.004 107.404L201.686 108.96Z',
      wheelHoverPathXl:
        'M434.353 234.262C433.377 246.89 431.3 259.408 428.145 271.674L386.968 261.084C389.506 251.216 391.177 241.145 391.962 230.985L434.353 234.262Z',
      shadeMatches: ['KL3P01', 'KL3P07', 'KL3P27']
    },
    {
      sku: '6MNY04',
      skuBaseId: 14120,
      wheelImage: 'Clinique_Foundation_17_Chelsey_Weimar_172_05_RGB.png',
      wheelHoverPathXs:
        'M200.162 120.182C199.045 125.956 197.426 131.622 195.323 137.114L176.884 130.055C178.576 125.636 179.879 121.078 180.777 116.432L200.162 120.182Z',
      wheelHoverPathXl:
        'M431.113 258.434C428.73 270.873 425.264 283.08 420.756 294.916L381.023 279.783C384.65 270.261 387.438 260.44 389.356 250.432L431.113 258.434Z',
      shadeMatches: ['KL3P01', 'KL3P04', 'KL3P23']
    },
    {
      sku: '6MNY49',
      skuBaseId: 95517,
      wheelImage: 'Clinique_Foundation_18_Anna_V_097_08_RGB.png',
      wheelHoverPathXs:
        'M197.391 131.163C195.635 136.776 193.391 142.225 190.686 147.447L173.154 138.368C175.33 134.166 177.135 129.782 178.548 125.266L197.391 131.163Z',
      wheelHoverPathXl:
        'M425.188 282.092C421.426 294.186 416.616 305.928 410.811 317.185L373.022 297.698C377.692 288.642 381.562 279.195 384.588 269.465L425.188 282.092Z',
      shadeMatches: ['KL3P04', 'KL3P07', 'KL3P23']
    },
    {
      sku: '6MNY16',
      skuBaseId: 14132,
      wheelImage: 'Clinique_Foundation_19_Vicky_Funari_152_10_RGB.png',
      wheelHoverPathXs:
        'M193.408 141.765C191.034 147.146 188.195 152.309 184.923 157.196L168.517 146.211C171.15 142.279 173.434 138.125 175.344 133.796L193.408 141.765Z',
      wheelHoverPathXl:
        'M416.651 304.938C411.559 316.534 405.464 327.664 398.436 338.2L363.066 314.606C368.72 306.129 373.624 297.175 377.72 287.845L416.651 304.938Z',
      shadeMatches: ['KL3P04', 'KL3P07', 'KL3P28']
    },
    {
      sku: '6MNY50',
      skuBaseId: 95518,
      wheelImage: 'Clinique_Foundation_20_Sofia_Resing_138_10_RGB.png',
      wheelHoverPathXs:
        'M188.263 151.854C185.302 156.935 181.903 161.748 178.104 166.238L163.031 153.485C166.088 149.873 168.823 146.001 171.205 141.913L188.263 151.854Z',
      wheelHoverPathXl:
        'M405.609 326.684C399.252 337.638 391.949 348.015 383.785 357.698L351.279 330.292C357.847 322.502 363.722 314.153 368.837 305.34L405.609 326.684Z',
      shadeMatches: ['KL3P01', 'KL3P04', 'KL3P26']
    },
    {
      sku: '6MNY05',
      skuBaseId: 14121,
      wheelImage: 'Clinique_Foundation_21_Lala_Olsson_302_10_RGB.png',
      wheelHoverPathXs:
        'M182.021 161.304C178.51 166.022 174.593 170.424 170.315 174.46L156.765 160.1C160.207 156.853 163.358 153.311 166.183 149.515L182.021 161.304Z',
      wheelHoverPathXl:
        'M392.203 347.057C384.659 357.23 376.241 366.725 367.044 375.433L337.811 344.56C345.21 337.554 351.982 329.915 358.052 321.731L392.203 347.057Z',
      shadeMatches: ['KL3P04', 'KL3P13', 'KL3P28']
    },
    {
      sku: '6MNY51',
      skuBaseId: 95519,
      wheelImage: 'Clinique_Foundation_22_Camila_Ribeiro_145_09_RGB.png',
      wheelHoverPathXs:
        'M174.761 169.995C170.743 174.29 166.358 178.226 161.655 181.758L149.798 165.972C153.582 163.13 157.11 159.963 160.342 156.508L174.761 169.995Z',
      wheelHoverPathXl:
        'M376.6 365.801C367.965 375.066 358.536 383.559 348.422 391.182L322.829 357.23C330.966 351.097 338.551 344.265 345.499 336.811L376.6 365.801Z',
      shadeMatches: ['KL3P04', 'KL3P15', 'KL3P18']
    },
    {
      sku: '6MNY26',
      skuBaseId: 31800,
      wheelImage: 'Clinique_Foundation_23_Wei_Mei_143_10_RGB.png',
      wheelHoverPathXs:
        'M166.573 177.819C162.1 181.638 157.301 185.058 152.233 188.041L142.218 171.026C146.295 168.626 150.156 165.874 153.754 162.802L166.573 177.819Z',
      wheelHoverPathXl:
        'M358.997 382.681C349.379 390.921 339.059 398.304 328.155 404.748L306.524 368.144C315.296 362.96 323.599 357.02 331.337 350.391L358.997 382.681Z',
      shadeMatches: ['KL3P04', 'KL3P13', 'KL3P23']
    },
    {
      sku: '6MNY06',
      skuBaseId: 14122,
      wheelImage: 'Clinique_Foundation_24_Alana_Monteiro_106_09_RGB.png',
      wheelHoverPathXs:
        'M157.56 184.678C152.688 187.971 147.537 190.833 142.166 193.23L134.119 175.201C138.44 173.272 142.584 170.97 146.504 168.32L157.56 184.678Z',
      wheelHoverPathXl:
        'M339.615 397.484C329.134 404.595 318.052 410.777 306.496 415.959L289.099 377.164C298.396 372.994 307.312 368.021 315.744 362.3L339.615 397.484Z',
      shadeMatches: ['KL3P04', 'KL3P13', 'KL3P18']
    },
    {
      sku: '6MNY11',
      skuBaseId: 14127,
      wheelImage: 'Clinique_Foundation_25_Astrid_Duran_088_04_RGB.png',
      wheelHoverPathXs:
        'M147.837 190.484C142.626 193.211 137.187 195.478 131.582 197.259L125.603 178.442C130.113 177.009 134.489 175.185 138.681 172.991L147.837 190.484Z',
      wheelHoverPathXl:
        'M318.697 410.024C307.486 415.917 295.782 420.819 283.718 424.675L270.774 384.176C280.479 381.074 289.896 377.13 298.915 372.389L318.697 410.024Z',
      shadeMatches: ['KL3P04', 'KL3P07', 'KL3P13']
    },
    {
      sku: '6MNY27',
      skuBaseId: 31801,
      wheelImage: 'Clinique_Foundation_26_Sarah_044_10_RGB.png',
      wheelHoverPathXs:
        'M137.524 195.165C132.041 197.292 126.382 198.935 120.613 200.077L116.779 180.71C121.42 179.791 125.973 178.468 130.384 176.757L137.524 195.165Z',
      wheelHoverPathXl:
        'M296.507 420.143C284.707 424.744 272.528 428.305 260.108 430.786L251.779 389.092C261.771 387.096 271.569 384.231 281.063 380.53L296.507 420.143Z',
      shadeMatches: ['KL3P04', 'KL3P13', 'KL3P18']
    },
    {
      sku: '6MNY35',
      skuBaseId: 82914,
      wheelImage: 'Clinique_Foundation_27_Jacky_Fideles_119_09_RGB.png',
      wheelHoverPathXs:
        'M126.752 198.662C121.065 200.161 115.258 201.161 109.397 201.65L107.756 181.975C112.471 181.582 117.143 180.777 121.718 179.571L126.752 198.662Z',
      wheelHoverPathXl:
        'M273.324 427.714C261.083 430.965 248.581 433.14 235.961 434.215L232.353 391.851C242.505 390.986 252.563 389.236 262.411 386.621L273.324 427.714Z',
      shadeMatches: ['KL3P07', 'KL3P15', 'KL3P28']
    },
    {
      sku: '6MNY52',
      skuBaseId: 95520,
      wheelImage: 'Clinique_Foundation_28_Lyric_Burns_052_07_RGB.png',
      wheelHoverPathXs:
        'M115.657 200.931C109.838 201.784 103.955 202.128 98.0762 201.958L98.6477 182.222C103.377 182.359 108.11 182.083 112.792 181.396L115.657 200.931Z',
      wheelHoverPathXl:
        'M249.438 432.642C236.91 434.502 224.244 435.264 211.583 434.919L212.74 392.418C222.925 392.695 233.116 392.082 243.195 390.586L249.438 432.642Z',
      shadeMatches: ['KL3P07', 'KL3P13', 'KL3P21']
    },
    {
      sku: '6MNY07',
      skuBaseId: 14123,
      wheelImage: 'Clinique_Foundation_29_Eloisa_089_05_RGB.png',
      wheelHoverPathXs:
        'M104.377 201.944C98.4988 202.14 92.6148 201.823 86.7919 200.996L89.5693 181.448C94.2539 182.114 98.9877 182.369 103.717 182.211L104.377 201.944Z',
      wheelHoverPathXl:
        'M225.151 434.865C212.494 435.311 199.822 434.65 187.279 432.89L193.187 390.785C203.277 392.201 213.472 392.733 223.656 392.374L225.151 434.865Z',
      shadeMatches: ['KL3P01', 'KL3P07', 'KL3P18']
    },
    {
      sku: '6MNY08',
      skuBaseId: 14124,
      wheelImage: 'Clinique_Foundation_30_Marina_Nery_065_06_RGB.png',
      wheelHoverPathXs:
        'M93.0545 201.687C87.1914 201.224 81.3799 200.25 75.6863 198.776L80.6346 179.663C85.2153 180.849 89.8907 181.632 94.6077 182.004L93.0545 201.687Z',
      wheelHoverPathXl:
        'M200.768 434.355C188.14 433.381 175.622 431.306 163.355 428.153L173.94 386.974C183.808 389.51 193.88 391.18 204.039 391.964L200.768 434.355Z',
      shadeMatches: ['KL3P04', 'KL3P14', 'KL3P28']
    },
    {
      sku: '6MNY53',
      skuBaseId: 95521,
      wheelImage: 'Clinique_Foundation_31_Cindy_Yan_041_06_RGB.png',
      wheelHoverPathXs:
        'M81.8321 200.164C76.0577 199.048 70.3917 197.43 64.8989 195.328L71.956 176.888C76.3751 178.58 80.9334 179.882 85.5791 180.78L81.8321 200.164Z',
      wheelHoverPathXl:
        'M176.595 431.119C164.156 428.737 151.949 425.273 140.112 420.767L155.24 381.032C164.763 384.657 174.584 387.444 184.592 389.36L176.595 431.119Z',
      shadeMatches: ['KL3P04', 'KL3P07', 'KL3P23']
    },
    {
      sku: '6MNY17',
      skuBaseId: 14133,
      wheelImage: 'Clinique_Foundation_32_Melina_DiMarco_146_09_RGB.png',
      wheelHoverPathXs:
        'M70.8507 197.395C65.2375 195.639 59.7884 193.397 54.5654 190.693L63.6426 173.16C67.8445 175.335 72.2284 177.139 76.7444 178.552L70.8507 197.395Z',
      wheelHoverPathXl:
        'M152.937 425.197C140.843 421.437 129.1 416.628 117.842 410.825L137.323 373.033C146.38 377.702 155.828 381.571 165.558 384.596L152.937 425.197Z',
      shadeMatches: ['KL3P13', 'KL3P21', 'KL3P23']
    },
    {
      sku: '6MNY28',
      skuBaseId: 31802,
      wheelImage: 'Clinique_Foundation_33_Yovanna_Ventura_131_04_RGB.png',
      wheelHoverPathXs:
        'M60.2484 193.414C54.867 191.041 49.7032 188.202 44.8158 184.931L55.7988 168.524C59.7308 171.156 63.8852 173.439 68.2146 175.349L60.2484 193.414Z',
      wheelHoverPathXl:
        'M130.09 416.663C118.493 411.573 107.362 405.479 96.8249 398.452L120.415 363.079C128.892 368.733 137.847 373.635 147.177 377.73L130.09 416.663Z',
      shadeMatches: ['KL3P04', 'KL3P13', 'KL3P23']
    },
    {
      sku: '6MNY29',
      skuBaseId: 31803,
      wheelImage: 'Clinique_Foundation_34_Pamela_Ramos_030_10_RGB.png',
      wheelHoverPathXs:
        'M50.1584 188.27C45.0765 185.31 40.263 181.911 35.7726 178.113L48.5234 163.039C52.136 166.094 56.0086 168.829 60.0971 171.211L50.1584 188.27Z',
      wheelHoverPathXl:
        'M108.343 405.625C97.3879 399.268 87.0093 391.967 77.3251 383.805L104.727 351.295C112.518 357.862 120.868 363.736 129.681 368.85L108.343 405.625Z',
      shadeMatches: ['KL3P01', 'KL3P15', 'KL3P28']
    },
    {
      sku: '6MNY09',
      skuBaseId: 14125,
      wheelImage: 'Clinique_Foundation_35_Dakota_Moore_053_06_RGB.png',
      wheelHoverPathXs:
        'M40.7077 182.03C35.9892 178.519 31.5864 174.603 27.5495 170.326L41.9078 156.774C45.1556 160.215 48.6977 163.365 52.4938 166.19L40.7077 182.03Z',
      wheelHoverPathXl:
        'M87.9674 392.221C77.7932 384.679 68.2972 376.261 59.5878 367.066L90.4569 337.828C97.4637 345.226 105.103 351.998 113.289 358.066L87.9674 392.221Z',
      shadeMatches: ['KL3P04', 'KL3P21', 'KL3P23']
    },
    {
      sku: '6MNY54',
      skuBaseId: 95522,
      wheelImage: 'Clinique_Foundation_36_Krithika_Reddy_244_05_RGB.png',
      wheelHoverPathXs:
        'M32.0151 174.77C27.7194 170.753 23.7827 166.369 20.25 161.667L36.0352 149.807C38.8773 153.59 42.0444 157.118 45.5004 160.35L32.0151 174.77Z',
      wheelHoverPathXl:
        'M69.2209 376.621C59.9551 367.987 51.4611 358.559 43.8359 348.447L77.7842 322.849C83.9188 330.985 90.7523 338.569 98.2069 345.516L69.2209 376.621Z',
      shadeMatches: ['KL3P04', 'KL3P13', 'KL3P28']
    },
    {
      sku: '6MNY18',
      skuBaseId: 14134,
      wheelImage: 'Clinique_Foundation_37_Bianca_Gittens_086_10_RGB.png',
      wheelHoverPathXs:
        'M24.1898 166.584C20.3708 162.111 16.9498 157.313 13.9657 152.245L30.9794 142.227C33.3801 146.305 36.1324 150.165 39.2049 153.763L24.1898 166.584Z',
      wheelHoverPathXl:
        'M52.3387 359.02C44.0978 349.403 36.7127 339.084 30.2676 328.181L66.8683 306.545C72.0535 315.316 77.9949 323.618 84.6249 331.356L52.3387 359.02Z',
      shadeMatches: ['KL3P04', 'KL3P13', 'KL3P18']
    },
    {
      sku: '6MNY36',
      skuBaseId: 82915,
      wheelImage: 'Clinique_Foundation_38_Diya_P_213_07_RGB.png',
      wheelHoverPathXs:
        'M17.3304 157.572C14.0361 152.7 11.1737 147.549 8.7758 142.179L26.804 134.129C28.7332 138.45 31.036 142.593 33.6863 146.513L17.3304 157.572Z',
      wheelHoverPathXl:
        'M37.5332 339.64C30.4208 329.16 24.2374 318.079 19.0534 306.524L57.8463 289.121C62.0169 298.418 66.9915 307.333 72.7136 315.764L37.5332 339.64Z',
      shadeMatches: ['KL3P14', 'KL3P21', 'KL3P28']
    },
    {
      sku: '6MNY15',
      skuBaseId: 14131,
      wheelImage: 'Clinique_Foundation_39_Daiane_Sodre_239_04_RGB.png',
      wheelHoverPathXs:
        'M11.5229 147.849C8.79478 142.639 6.52701 137.2 4.74542 131.595L23.5615 125.614C24.9948 130.124 26.8193 134.499 29.0141 138.691L11.5229 147.849Z',
      wheelHoverPathXl:
        'M24.9904 318.724C19.096 307.514 14.1921 295.811 10.3344 283.747L50.8316 270.797C53.9352 280.502 57.8805 289.918 62.6227 298.937L24.9904 318.724Z',
      shadeMatches: ['KL3P04', 'KL3P15', 'KL3P23']
    },
    {
      sku: '6MNY37',
      skuBaseId: 82916,
      wheelImage: 'Clinique_Foundation_40_Iesha_Hodges_092_04_RGB.png',
      wheelHoverPathXs:
        'M6.8404 137.537C4.71279 132.054 3.06817 126.396 1.92529 120.627L21.2927 116.79C22.2121 121.431 23.5353 125.984 25.247 130.395L6.8404 137.537Z',
      wheelHoverPathXl:
        'M14.8682 296.535C10.2659 284.736 6.70296 272.557 4.22013 260.137L45.9126 251.803C47.9101 261.794 50.7765 271.592 54.4792 281.085L14.8682 296.535Z',
      shadeMatches: ['KL3P04', 'KL3P15', 'KL3P28']
    },
    {
      sku: '6MNY30',
      skuBaseId: 31804,
      wheelImage: 'Clinique_Foundation_41_Cai_028_05_RGB.png',
      wheelHoverPathXs:
        'M4.34184 126.766C2.84146 121.079 1.84066 115.272 1.35086 109.411L21.026 107.767C21.4201 112.482 22.2252 117.154 23.4323 121.729L4.34184 126.766Z',
      wheelHoverPathXl:
        'M8.29369 273.353C5.0413 261.112 2.8643 248.611 1.7875 235.992L44.151 232.377C45.0173 242.529 46.7687 252.587 49.3853 262.435L8.29369 273.353Z',
      shadeMatches: ['KL3P01', 'KL3P15', 'KL3P28']
    },
    {
      sku: '6MNY38',
      skuBaseId: 82917,
      wheelImage: 'Clinique_Foundation_42_Pritika_212_07_RGB.png',
      wheelHoverPathXs:
        'M2.07117 115.671C1.21688 109.852 0.872486 103.969 1.04192 98.0903L20.7775 98.6591C20.6411 103.389 20.9182 108.121 21.6055 112.803L2.07117 115.671Z',
      wheelHoverPathXl:
        'M3.36219 249.468C1.50064 236.941 0.736893 224.274 1.07967 211.613L43.5815 212.764C43.3058 222.95 43.9202 233.14 45.4179 243.219L3.36219 249.468Z',
      shadeMatches: ['KL3P15', 'KL3P22', 'KL3P29']
    },
    {
      sku: '6MNY12',
      skuBaseId: 14128,
      wheelImage: 'Clinique_Foundation_43_Rossy_Herrera_169_08_RGB.png',
      wheelHoverPathXs:
        'M1.05694 104.391C0.85948 98.5129 1.17582 92.6289 2.00237 86.8059L21.5502 89.5806C20.8852 94.2653 20.6307 98.9991 20.7895 103.728L1.05694 104.391Z',
      wheelHoverPathXl:
        'M1.13569 225.182C0.688379 212.524 1.3475 199.852 3.10555 187.309L45.2114 193.211C43.797 203.302 43.2667 213.497 43.6266 223.68L1.13569 225.182Z',
      shadeMatches: ['KL3P04', 'KL3P15', 'KL3P28']
    },
    {
      sku: '6MNY55',
      skuBaseId: 95523,
      wheelImage: 'Clinique_Foundation_44_Cici_Ali_115_09_RGB.png',
      wheelHoverPathXs:
        'M1.3119 93.0686C1.77376 87.2054 2.74686 81.3938 4.22012 75.6999L23.3344 80.6456C22.1491 85.2264 21.3662 89.902 20.9947 94.6191L1.3119 93.0686Z',
      wheelHoverPathXl:
        'M1.64219 200.798C2.61474 188.171 4.68844 175.652 7.83965 163.385L49.0201 173.963C46.4849 183.832 44.8165 193.904 44.0341 204.063L1.64219 200.798Z',
      shadeMatches: ['KL3P09', 'KL3P15', 'KL3P28']
    },
    {
      sku: '6MNY10',
      skuBaseId: 14126,
      wheelImage: 'Clinique_Foundation_45_Lisa_Washington_113_09_RGB.png',
      wheelHoverPathXs:
        'M1.83285 81.846C2.94821 76.0713 4.56584 70.4052 6.66729 64.9121L25.1077 71.9666C23.417 76.3859 22.1156 80.9445 21.2183 85.5903L1.83285 81.846Z',
      wheelHoverPathXl:
        'M3.87532 176.625C6.25551 164.186 9.71771 151.978 14.2225 140.141L53.9597 155.263C50.3355 164.786 47.5501 174.608 45.6352 184.616L3.87532 176.625Z',
      shadeMatches: ['KL3P04', 'KL3P13', 'KL3P29']
    },
    {
      sku: '6MNY56',
      skuBaseId: 95524,
      wheelImage: 'Clinique_Foundation_46_Ariela_Soares_043_08_RGB.png',
      wheelHoverPathXs:
        'M4.60066 70.8642C6.35551 65.2507 8.59732 59.8013 11.3005 54.578L28.8352 63.6526C26.6604 67.8549 24.8568 72.2391 23.445 76.7552L4.60066 70.8642Z',
      wheelHoverPathXl:
        'M9.79443 152.966C13.5523 140.871 18.3595 129.127 24.1611 117.869L61.9555 137.345C57.288 146.403 53.4205 155.851 50.3972 165.581L9.79443 152.966Z',
      shadeMatches: ['KL3P04', 'KL3P15', 'KL3P28']
    },
    {
      sku: '6MNY31',
      skuBaseId: 31805,
      wheelImage: 'Clinique_Foundation_47_Dominique_Robinson_078_05_RGB.png',
      wheelHoverPathXs:
        'M8.58054 60.2613C10.9528 54.8796 13.7906 49.7154 17.0616 44.8275L33.4701 55.8083C30.8385 59.7406 28.5555 63.8953 26.6469 68.225L8.58054 60.2613Z',
      wheelHoverPathXl:
        'M18.3251 130.118C23.4134 118.52 29.5052 107.388 36.5308 96.8502L71.9071 120.435C66.2549 128.913 61.354 137.869 57.2603 147.2L18.3251 130.118Z',
      shadeMatches: ['KL3P19', 'KL3P22', 'KL3P29']
    },
    {
      sku: '6MNY57',
      skuBaseId: 95525,
      wheelImage: 'Clinique_Foundation_48_Alima_Fofana_127_05_RGB.png',
      wheelHoverPathXs:
        'M13.7224 50.1706C16.6823 45.0883 20.0804 40.2743 23.8781 35.7834L38.9541 48.5321C35.8988 52.1451 33.1649 56.0181 30.7837 60.1069L13.7224 50.1706Z',
      wheelHoverPathXl:
        'M29.36 108.369C35.7149 97.4132 43.0145 87.0336 51.1757 77.3483L83.6892 104.746C77.1234 112.537 71.2507 120.888 66.1381 129.702L29.36 108.369Z',
      shadeMatches: ['KL3P25', 'KL3P30', 'KL3P29']
    },
    {
      sku: '6MNY13',
      skuBaseId: 14129,
      wheelImage: 'Clinique_Foundation_49_Paige_G_065_09_RGB.png',
      wheelHoverPathXs:
        'M19.9617 40.719C23.4719 36.0001 27.3877 31.5967 31.6642 27.5592L45.2181 41.9156C41.7776 45.1639 38.6273 48.7064 35.8033 52.5029L19.9617 40.719Z',
      wheelHoverPathXl:
        'M42.7605 87.9918C50.302 77.8165 58.7178 68.3194 67.912 59.6087L97.1538 90.4736C89.7569 97.4816 82.9863 105.122 76.919 113.308L42.7605 87.9918Z',
      shadeMatches: ['KL3P19', 'KL3P22', 'KL3P29']
    },
    {
      sku: '6MNY32',
      skuBaseId: 31806,
      wheelImage: 'Clinique_Foundation_50_Ovo_011_09_RGB.png',
      wheelHoverPathXs:
        'M27.2199 32.0254C31.2364 27.7291 35.6204 23.7918 40.3221 20.2585L52.1836 36.042C48.401 38.8847 44.8739 42.0523 41.6426 45.5087L27.2199 32.0254Z',
      wheelHoverPathXl:
        'M58.3581 69.2431C66.9913 59.9761 76.4174 51.4808 86.529 43.8542L112.132 77.7989C103.997 83.9347 96.4131 90.7692 89.4676 98.2247L58.3581 69.2431Z',
      shadeMatches: ['KL3P22', 'KL3P25', 'KL3P29']
    },
    {
      sku: '6MNY58',
      skuBaseId: 95527,
      wheelImage: 'Clinique_Foundation_51_Mame_Adjei_010_07_RGB.png',
      wheelHoverPathXs:
        'M35.4058 24.199C39.878 20.3793 44.6753 16.9576 49.743 13.9729L59.7628 30.9852C55.6858 33.3864 51.8263 36.1393 48.2283 39.2122L35.4058 24.199Z',
      wheelHoverPathXl:
        'M75.9566 52.3585C85.573 44.1163 95.8909 36.7297 106.793 30.2831L128.434 66.8807C119.663 72.0671 111.362 78.0097 103.626 84.6408L75.9566 52.3585Z',
      shadeMatches: ['KL3P19', 'KL3P25', 'KL3P29']
    },
    {
      sku: '6MNY19',
      skuBaseId: 14135,
      wheelImage: 'Clinique_Foundation_52_Sasha_Colin_007_09_RGB.png',
      wheelHoverPathXs:
        'M44.4164 17.3382C49.2881 14.0433 54.4383 11.1802 59.8083 8.78154L67.8606 26.8086C63.5403 28.7384 59.3969 31.0418 55.4775 33.6926L44.4164 17.3382Z',
      wheelHoverPathXl:
        'M95.3348 37.5503C105.813 30.4364 116.894 24.2515 128.449 19.0659L145.857 57.8563C136.56 62.0282 127.646 67.0041 119.216 72.7273L95.3348 37.5503Z',
      shadeMatches: ['KL3P22', 'KL3P25', 'KL3P29']
    },
    {
      sku: '6MNY20',
      skuBaseId: 14136,
      wheelImage: 'Clinique_Foundation_53_Farhiya_Shire_020_10_RGB.png',
      wheelHoverPathXs:
        'M54.1384 11.5294C59.3484 8.80058 64.7868 6.53206 70.3916 4.74969L76.375 23.5649C71.8658 24.9989 67.4905 26.8239 63.299 29.0193L54.1384 11.5294Z',
      wheelHoverPathXl:
        'M116.249 25.0046C127.458 19.1086 139.161 14.203 151.224 10.3437L164.18 50.8391C154.475 53.944 145.06 57.8907 136.042 62.6341L116.249 25.0046Z',
      shadeMatches: ['KL3P16', 'KL3P22', 'KL3P25']
    },
    {
      sku: '6MNY59',
      skuBaseId: 95528,
      wheelImage: 'Clinique_Foundation_54_Walda_063_07_RGB.png',
      wheelHoverPathXs:
        'M64.4496 6.84549C69.9324 4.71712 75.5906 3.07171 81.3596 1.92802L85.199 21.2949C80.5577 22.215 76.0056 23.5387 71.5946 25.251L64.4496 6.84549Z',
      wheelHoverPathXl:
        'M138.436 14.8792C150.235 10.2753 162.414 6.71066 174.833 4.22609L183.173 45.9174C173.182 47.9163 163.384 50.7841 153.892 54.4881L138.436 14.8792Z',
      shadeMatches: ['KL3P16', 'KL3P25', 'KL3P29']
    },
    {
      sku: '6MNY33',
      skuBaseId: 31807,
      wheelImage: 'Clinique_Foundation_55_Amira_Pinheiro_071_08_RGB.png',
      wheelHoverPathXs:
        'M75.2205 4.34543C80.907 2.84425 86.7138 1.84265 92.5747 1.35203L94.2217 21.0269C89.5065 21.4217 84.8348 22.2275 80.2599 23.4352L75.2205 4.34543Z',
      wheelHoverPathXl:
        'M161.618 8.3015C173.858 5.0474 186.359 2.86865 198.978 1.79009L202.599 44.1531C192.446 45.0208 182.389 46.7736 172.542 49.3916L161.618 8.3015Z',
      shadeMatches: ['KL3P19', 'KL3P25', 'KL3P29']
    },
    {
      sku: '6MNY60',
      skuBaseId: 95530,
      wheelImage: 'Clinique_Foundation_56_Aluad_Anel_160_07_RGB.png',
      wheelHoverPathXs:
        'M86.3154 2.07321C92.1343 1.21811 98.0167 0.8729 103.896 1.04152L103.33 20.7771C98.5999 20.6415 93.8674 20.9192 89.186 21.6071L86.3154 2.07321Z',
      wheelHoverPathXl:
        'M185.502 3.36666C198.029 1.50335 210.695 0.737842 223.356 1.07885L222.211 43.5809C212.026 43.3065 201.835 43.9224 191.757 45.4215L185.502 3.36666Z',
      shadeMatches: ['KL3P25', 'KL3P30', 'KL3P29']
    }
  ];

  function hookFoundationShadeFinderDialogs() {
    var isMobileDevice = window.matchMedia('only screen and (max-width: 760px)').matches;

    window.foundationShadeFinderV1 = {
      selectFoundation: {
        dialog: {},
        templates: {},
        selectors: {}
      },
      selectedFoundation: {
        dialog: {},
        templates: {},
        selectors: {}
      },
      foundationProductSkus: [],
      choosenShade: {},
      selectedMatches: [],
      isMobileDevice: isMobileDevice,
      openSelectFoundationDialog: openSelectFoundationDialog
    };

    var selectFoundationDialogElement = document.querySelector(
      '.foundation-shade-finder__select-foundation-dialog'
    );
    var selectedFoundationDialogElement = document.querySelector(
      '.foundation-shade-finder__selected-foundation-dialog'
    );
    var dialogOverlayElement = document.querySelector('.foundation-shade-finder__dialog-overlay');

    window.foundationShadeFinderV1.selectFoundation.dialog = new FoundationShadeFinderDialog(
      selectFoundationDialogElement,
      dialogOverlayElement
    );

    window.foundationShadeFinderV1.selectedFoundation.dialog = new FoundationShadeFinderDialog(
      selectedFoundationDialogElement,
      dialogOverlayElement
    );

    var wheelInitialId = window.isMobileDevice ? 'wheel-xs-initial' : 'wheel-xl-initial';
    var wheelTemplateId = window.isMobileDevice ? 'wheel-xs-template' : 'wheel-xl-template';

    addEventToSvgs(wheelInitialId);
    addEventToSvgs(wheelTemplateId);
  }

  function defineSelectorsForSelectFoundationDialog() {
    window.foundationShadeFinderV1.selectFoundation.selectors = {
      foundationOptionsContainer: document.querySelector(
        '.foundation-shade-finder__foundation-options-content'
      ),
      selectedFoundationContentElement: document.querySelector(
        '.foundation-shade-finder__selected-foundation-content'
      ),
      selectedFoundationProductELement: document.querySelector(
        '.foundation-shade-finder__selected-foundation-product'
      ),
      selectedFoundationProductContentELement: document.querySelector(
        '.foundation-shade-finder__selected-foundation-product .foundation-shade-finder__content'
      ),
      needHelpElement: document.querySelector('.foundation-shade-finder__need-help'),
      selectYourFoundationTitleElement: document.querySelector(
        '.foundation-shade-finder__select-your-foundation-title'
      ),
      selectShadeButton: document.querySelector('.foundation-shade-finder__select-shade-button'),
      selectFoundationButton: document.querySelector(
        '.foundation-shade-finder__select-foundation-button'
      ),
      closeButton: document.querySelector(
        '.foundation-shade-finder__dialog1 .foundation-shade-finder__close-button'
      )
    };

    compileTemplatesForSelectFoundationDialog(window.foundationShadeFinderV1.isMobileDevice);
  }

  function compileTemplatesForSelectFoundationDialog(isMobileDevice) {
    var wheelImageElementId = isMobileDevice
      ? 'wheel-image-template-xs'
      : 'wheel-image-template-xl';
    var wheelImageSource = document.getElementById(wheelImageElementId).innerHTML;
    var foundationOptionSource = document.getElementById('foundation-option-template').innerHTML;
    var selectedFoundationOptionSource = document.getElementById(
      'selected-foundation-option-template'
    ).innerHTML;
    var selectedFoundationProductSource = document.getElementById(
      'selected-foundation-product-template'
    ).innerHTML;

    window.foundationShadeFinderV1.selectFoundation.templates = {
      wheelImageTemplate: wheelImageSource,
      foundationOptionTemplate: foundationOptionSource,
      selectedFoundationOptionTemplate: selectedFoundationOptionSource,
      selectedFoundationProductTemplate: selectedFoundationProductSource
    };
    if (isMobileDevice) {
      window.foundationShadeFinderV1.selectFoundation.selectors.selectShadeButton.addEventListener(
        'click',
        openDialog2
      );
      $(window).scrollTop(0);
    }

    window.foundationShadeFinderV1.selectFoundation.selectors.closeButton.addEventListener(
      'click',
      function () {
        window.foundationShadeFinderV1.selectFoundation.dialog.closeDialog();
      }
    );
    addEventToSelectFoundationShadeButton();
    renderFoundationOptions(isMobileDevice);
  }

  function openSelectFoundationDialog() {
    window.foundationShadeFinderV1.selectFoundation.dialog.openDialog(
      defineSelectorsForSelectFoundationDialog
    );
  }

  function renderFoundationOptions(isMobileDevice) {
    var foundationOptionElements = document.querySelectorAll(
      '.foundation-shade-finder__dialog1 .foundation-shade-finder__foundation-option'
    );

    if (foundationOptionElements.length > 0) {
      return;
    }

    var foundationProductIndex = page_data['product-input-type'].products
      .map(function (x) {
        return x.PRODUCT_ID;
      })
      .indexOf('PROD5276');

    if (foundationProductIndex !== -1) {
      var aditionalSkuBaseIds = foundationProductSkusAdditionalData.map(function (x) {
        return x.skuBaseId;
      });

      window.foundationShadeFinderV1.foundationProductSkus = page_data[
        'product-input-type'
      ].products[foundationProductIndex].skus.map(function (sku) {
        var additionalSkuBaseIdIndex = aditionalSkuBaseIds.indexOf(sku.SKU_BASE_ID);
        var additionalData = foundationProductSkusAdditionalData[additionalSkuBaseIdIndex];
        var shadeNameSplitted = sku.SHADENAME.split(' ');

        return {
          colourGroup: sku.ATTRIBUTE_COLOR_FAMILY_2,
          hexValue: sku.HEX_VALUE_STRING.toLowerCase(),
          shadeSize: shadeNameSplitted[0] + ' ' + shadeNameSplitted[1],
          shadeName: shadeNameSplitted.splice(2).join(' '),
          undertone: sku.UNDERTONE,
          sku: additionalData.sku,
          skuBaseId: sku.SKU_BASE_ID,
          wheelImage: additionalData.wheelImage,
          wheelHoverPathXs: additionalData.wheelHoverPathXs,
          wheelHoverPathXl: additionalData.wheelHoverPathXl,
          shadeMatches: additionalData.shadeMatches
        };
      });
    }

    window.foundationShadeFinderV1.foundationProductSkus.forEach(function (p) {
      var context = {
        name: p.shadeSize,
        color: p.hexValue
      };
      var html = Mustache.render(
        window.foundationShadeFinderV1.selectFoundation.templates.foundationOptionTemplate,
        context
      );

      window.foundationShadeFinderV1.selectFoundation.selectors.foundationOptionsContainer.insertAdjacentHTML(
        'beforeend',
        html
      );

      window.foundationShadeFinderV1.selectFoundation.selectors.foundationOptionsContainer.addEventListener(
        'scroll',
        function (element) {
          if (
            element.target.scrollHeight - element.target.scrollTop <=
            element.target.clientHeight
          ) {
            this.classList.remove('show-gradient');
          } else {
            this.classList.add('show-gradient');
          }
        }
      );
    });

    var foundationOptionElements = document.querySelectorAll(
      '.foundation-shade-finder__dialog1 .foundation-shade-finder__foundation-option'
    );

    addEventsToFoundationOptions(foundationOptionElements, isMobileDevice);
  }

  function addSelectionToFoundationOptionElement(
    foundationOptionElements,
    currentElement,
    isMobileDevice
  ) {
    foundationOptionElements.forEach(function (element) {
      if (!element.classList.contains('foundation-shade-finder__active-foundation-shade')) {
        element.setAttribute('style', 'background-color:#fff;');
      }

      if (isMobileDevice) {
        var shadeElement = element.querySelector(
          '.foundation-shade-finder__content .foundation-shade-finder__color'
        );

        shadeElement.style.border = 'none';
        shadeElement.style.boxSizing = 'content-box';
      }
    });

    var colorElement = currentElement.querySelector(
      '.foundation-shade-finder__content .foundation-shade-finder__color'
    );
    var color = colorElement.style.backgroundColor;
    var colorInHex = colorElement.dataset.color.toLowerCase();

    if (isMobileDevice) {
      colorElement.style.border = '2px solid #000';
      colorElement.style.boxSizing = 'border-box';
    } else {
      currentElement.setAttribute('style', 'background-color:' + color + ';');
    }

    var matchingShadeIndex = window.foundationShadeFinderV1.foundationProductSkus
      .map(function (p) {
        return p.hexValue;
      })
      .indexOf(colorInHex);
    var matchingShade = window.foundationShadeFinderV1.foundationProductSkus[matchingShadeIndex];

    if (matchingShade) {
      renderSelectedFoundationELementData(matchingShade, isMobileDevice, false);
    }
  }

  function addEventsToFoundationOptions(foundationOptionElements, isMobileDevice) {
    for (var i = 0; i < foundationOptionElements.length; i++) {
      (function (index) {
        var currentElement = foundationOptionElements[index];

        currentElement.addEventListener('click', function () {
          if (!isMobileDevice) {
            addClickEventToFoundationShade(foundationOptionElements, currentElement);
          } else {
            currentElement.addEventListener(
              'click',
              addSelectionToFoundationOptionElement(
                foundationOptionElements,
                currentElement,
                isMobileDevice
              )
            );
          }
        });
        currentElement.addEventListener('mouseover', function () {
          addSelectionToFoundationOptionElement(
            foundationOptionElements,
            currentElement,
            isMobileDevice
          );
        });
      })(i);
    }
  }

  function addClickEventToFoundationShade(foundationOptionElements, currentElement) {
    var foundationOptionElements = document.querySelectorAll(
      '.foundation-shade-finder__dialog1 .foundation-shade-finder__foundation-option'
    );

    foundationOptionElements.forEach(function (element) {
      if (element.classList.contains('foundation-shade-finder__active-foundation-shade')) {
        element.classList.remove('foundation-shade-finder__active-foundation-shade');
        element.setAttribute('style', 'background-color:#fff;');
      }
    });

    currentElement.classList.add('foundation-shade-finder__active-foundation-shade');
    window.foundationShadeFinderV1.selectFoundation.selectors.selectFoundationButton.disabled = false;

    var colorElement = currentElement.querySelector(
      '.foundation-shade-finder__content .foundation-shade-finder__color'
    );
    var colorInHex = colorElement.dataset.color.toLowerCase();
    var matchingShadeIndex = window.foundationShadeFinderV1.foundationProductSkus
      .map(function (p) {
        return p.hexValue;
      })
      .indexOf(colorInHex);
    var matchingShade = window.foundationShadeFinderV1.foundationProductSkus[matchingShadeIndex];
    var selectedPath = document.getElementById('wheel-xl-template').querySelector('path#selected');

    selectedPath.setAttribute('fill', matchingShade.hexValue);
    selectedPath.setAttribute('d', matchingShade.wheelHoverPathXl);

    window.foundationShadeFinderV1.choosenShade = matchingShade;
  }

  function addEventToSelectFoundationShadeButton() {
    window.foundationShadeFinderV1.selectFoundation.selectors.selectFoundationButton.addEventListener(
      'click',
      function () {
        clearHoverOnFoundationListAndWheel();
        openDialog2();
      }
    );
  }

  function clearHoverOnFoundationListAndWheel() {
    var foundationOptionElements = document.querySelectorAll(
      '.foundation-shade-finder__dialog1 .foundation-shade-finder__foundation-option'
    );

    foundationOptionElements.forEach(function (element) {
      if (!element.classList.contains('foundation-shade-finder__active-foundation-shade')) {
        element.setAttribute('style', 'background-color:#fff;');
      }
    });

    var hoverPath = document.getElementById('wheel-xl-template').querySelector('path#hover');

    hoverPath.setAttribute('fill', '');
    hoverPath.setAttribute('d', '');
  }

  function openDialog2() {
    clearSelectedMatches();
    window.foundationShadeFinderV1.selectedFoundation.dialog.openDialog(
      defineSelectorsForSelectedFoundationDialog
    );
  }

  function addEventToSvgs(svgId) {
    var svgElement = document.getElementById(svgId);
    var wheelPaths = svgElement.querySelectorAll('path');
    var isMobileDevice = window.foundationShadeFinderV1.isMobileDevice;
    var templateId = isMobileDevice ? 'wheel-xs-template' : 'wheel-xl-template';
    var initialTemplateId = isMobileDevice ? 'wheel-xs-initial' : 'wheel-xl-initial';

    wheelPaths.forEach(function (path) {
      path.addEventListener('mouseover', function (event) {
        if (event && event.target && event.target.attributes && event.target.attributes.fill) {
          if (
            event.target.attributes.fill.nodeValue !== 'white' &&
            event.target.attributes.fill.nodeValue !== 'black'
          ) {
            var svgHexValue = event.target.attributes.fill.nodeValue.toLowerCase();
            var matchingShadeIndex = window.foundationShadeFinderV1.foundationProductSkus
              .map(function (p) {
                return p.hexValue;
              })
              .indexOf(svgHexValue);
            var matchingShade =
              window.foundationShadeFinderV1.foundationProductSkus[matchingShadeIndex];

            if (matchingShade) {
              if (svgElement.id === templateId) {
                renderSelectedFoundationELementData(matchingShade, isMobileDevice, true);
              }
              if (svgElement.id === initialTemplateId) {
                svgElement.remove();
                document.getElementById(templateId).setAttribute('style', 'visibility: visible');
              }
            }
          }
        }
      });

      path.addEventListener('click', function (event) {
        if (event && event.target && event.target.attributes && event.target.attributes.fill) {
          if (
            event.target.attributes.fill.nodeValue !== 'white' &&
            event.target.attributes.fill.nodeValue !== 'black'
          ) {
            var svgHexValue = event.target.attributes.fill.nodeValue.toLowerCase();
            var foundationOption = document.getElementById('hex-' + svgHexValue);

            addClickEventToFoundationShade(null, foundationOption);
          }
        }
      });
    });
  }

  function renderSelectedFoundationELementData(matchingShade, isMobileDevice, scrollIntoView) {
    if (isMobileDevice) {
      window.foundationShadeFinderV1.choosenShade = matchingShade;
    }

    var wheelInitialId = isMobileDevice ? 'wheel-xs-initial' : 'wheel-xl-initial';
    var wheelInitial = document.getElementById(wheelInitialId);

    if (wheelInitial) {
      wheelInitial.remove();
    }

    window.foundationShadeFinderV1.selectFoundation.selectors.needHelpElement.setAttribute(
      'style',
      'display: none;'
    );
    window.foundationShadeFinderV1.selectFoundation.selectors.selectYourFoundationTitleElement.setAttribute(
      'style',
      'display: none;'
    );

    window.foundationShadeFinderV1.selectFoundation.selectors.selectedFoundationContentElement.setAttribute(
      'style',
      'display: block;'
    );
    window.foundationShadeFinderV1.selectFoundation.selectors.selectedFoundationProductELement.setAttribute(
      'style',
      'background-color:' + matchingShade.hexValue + ';'
    );

    if (scrollIntoView) {
      document
        .querySelectorAll(
          '.foundation-shade-finder__dialog1 .foundation-shade-finder__foundation-option'
        )
        .forEach(function (element) {
          if (!element.classList.contains('foundation-shade-finder__active-foundation-shade')) {
            element.setAttribute('style', 'background-color:#fff;');
          }
        });

      var foundationOption = document.getElementById('hex-' + matchingShade.hexValue);

      foundationOption.setAttribute('style', 'background-color:' + matchingShade.hexValue + ';');

      // polyfill for IE and EDGE
      foundationOption.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      });
    }

    window.foundationShadeFinderV1.selectFoundation.selectors.selectedFoundationProductContentELement.setAttribute(
      'style',
      'display: block;'
    );

    var optionContext = {
      colourGroup: matchingShade.colourGroup,
      undertone: matchingShade.undertone
    };
    var optionHtml = Mustache.render(
      window.foundationShadeFinderV1.selectFoundation.templates.selectedFoundationOptionTemplate,
      optionContext
    );

    window.foundationShadeFinderV1.selectFoundation.selectors.selectedFoundationContentElement.innerHTML = optionHtml;

    var productContext = {
      shadeName: matchingShade.shadeName,
      shadeSize: matchingShade.shadeSize,
      productSku: matchingShade.sku
    };
    var productHtml = Mustache.render(
      window.foundationShadeFinderV1.selectFoundation.templates.selectedFoundationProductTemplate,
      productContext
    );

    window.foundationShadeFinderV1.selectFoundation.selectors.selectedFoundationProductContentELement.innerHTML = productHtml;

    var wheelImageContext = {
      wheelImageUrl: matchingShade.wheelImage
    };
    var wheelImageHtml = Mustache.render(
      window.foundationShadeFinderV1.selectFoundation.templates.wheelImageTemplate,
      wheelImageContext
    );
    var wheelTemplateID = isMobileDevice ? 'wheel-xs-template' : 'wheel-xl-template';

    document.getElementById(wheelTemplateID).setAttribute('style', 'visibility: visible;');

    var wheelContentDocument = document.getElementById(wheelTemplateID);

    wheelContentDocument.querySelector('defs').innerHTML = wheelImageHtml;

    var hoverPath = wheelContentDocument.querySelector('path#hover');
    var path = isMobileDevice ? matchingShade.wheelHoverPathXs : matchingShade.wheelHoverPathXl;

    hoverPath.setAttribute('fill', matchingShade.hexValue);
    hoverPath.setAttribute('d', path);

    window.foundationShadeFinderV1.selectFoundation.selectors.selectShadeButton.disabled = false;
  }

  /* dialog 2 */

  function defineSelectorsForSelectedFoundationDialog() {
    window.foundationShadeFinderV1.selectedFoundation.selectors = {
      lipShadeFinderELement: document.querySelector('.foundation-shade-finder__lip-shade-finder'),
      selectedFoundationProductContentELement: document.querySelector(
        '.foundation-shade-finder__selected-foundation-dialog .foundation-shade-finder__product .foundation-shade-finder__content'
      ),
      foundationOptionElement: document.querySelector(
        '.foundation-shade-finder__dialog2 .foundation-shade-finder__foundation-option'
      ),
      shadeMatchesContentELement: document.querySelector('.foundation-shade-finder__shade-matches'),
      closeButton: document.querySelector(
        '.foundation-shade-finder__dialog2 .foundation-shade-finder__close-button'
      ),
      backButton: document.querySelector(
        '.foundation-shade-finder__dialog2 .foundation-shade-finder__back-button'
      ),
      addToBagButton: document.querySelector(
        '.foundation-shade-finder__dialog2 .foundation-shade-finder__add-to-bag-button'
      )
    };

    compileTemplatesForSelectedFoundationDialog();

    var productContext = {
      shadeSize: window.foundationShadeFinderV1.choosenShade.shadeSize,
      shadeName: window.foundationShadeFinderV1.choosenShade.shadeName,
      productSku: window.foundationShadeFinderV1.choosenShade.sku,
      color: window.foundationShadeFinderV1.choosenShade.hexValue
    };
    var productHtml = Mustache.render(
      window.foundationShadeFinderV1.selectedFoundation.templates
        .dialog2SelectedFoundationProductTemplate,
      productContext
    );

    window.foundationShadeFinderV1.selectedFoundation.selectors.selectedFoundationProductContentELement.innerHTML = productHtml;

    var shadeMatchContext = [];

    window.foundationShadeFinderV1.choosenShade.shadeMatches.forEach(function (p, index) {
      var lookName =
        window.foundationShadeFinderV1.selectedFoundation.selectors.shadeMatchesContentELement
          .dataset['lookName-' + index];
      var skuInfoIndex = page_data['product-input-type'].skus
        .map(function (x) {
          return x.PRODUCT_CODE;
        })
        .indexOf(p);
      var skuInfo = page_data['product-input-type'].skus[skuInfoIndex];
      var skuDisplayInfo = {
        productCode: skuInfo.PRODUCT_CODE,
        shadeName: skuInfo.SHADENAME,
        skuBaseId: skuInfo.SKU_BASE_ID,
        formattedPrice: skuInfo.formattedPrice,
        shortDescription: skuInfo.product.SHORT_DESC,
        productName: skuInfo.product.PROD_RGN_NAME,
        url: skuInfo.product.url
      };

      shadeMatchContext.push({
        lookName: lookName,
        skuDisplayInfo: skuDisplayInfo
      });
    });

    var shadeMatchHtml = Mustache.render(
      window.foundationShadeFinderV1.selectedFoundation.templates.dialog2ShadeMatchesTemplate,
      shadeMatchContext
    );

    window.foundationShadeFinderV1.selectedFoundation.selectors.shadeMatchesContentELement.innerHTML = shadeMatchHtml;

    var optionContext = {
      colourGroup: window.foundationShadeFinderV1.choosenShade.colourGroup,
      undertone: window.foundationShadeFinderV1.choosenShade.undertone
    };
    var optionHtml = Mustache.render(
      window.foundationShadeFinderV1.selectedFoundation.templates.dialog2FoundationOptionTemplate,
      optionContext
    );

    window.foundationShadeFinderV1.selectedFoundation.selectors.foundationOptionElement.innerHTML = optionHtml;

    addEventToLipShadeFinderLabel();
    addEventsToProductMatches();
    addEventToAddToBagButton();
    changeStateOfAddToBagButton();
  }

  function compileTemplatesForSelectedFoundationDialog() {
    var dialog2SelectedFoundationProductSource = document.getElementById(
      'dialog2-selected-foundation-product-template'
    ).innerHTML;
    var dialog2FoundationOptionSource = document.getElementById(
      'dialog2-foundation-option-template'
    ).innerHTML;
    var dialog2ShadeMatchesSource = document.getElementById('dialog2-shade-matches-template')
      .innerHTML;

    window.foundationShadeFinderV1.selectedFoundation.templates = {
      dialog2SelectedFoundationProductTemplate: dialog2SelectedFoundationProductSource,
      dialog2FoundationOptionTemplate: dialog2FoundationOptionSource,
      dialog2ShadeMatchesTemplate: dialog2ShadeMatchesSource
    };

    window.foundationShadeFinderV1.selectedFoundation.selectors.closeButton.addEventListener(
      'click',
      function () {
        window.foundationShadeFinderV1.selectedFoundation.dialog.closeDialogWithoutOverlay();
      }
    );

    window.foundationShadeFinderV1.selectedFoundation.selectors.backButton.addEventListener(
      'click',
      function () {
        window.foundationShadeFinderV1.selectedFoundation.dialog.closeDialogWithoutOverlay();
      }
    );
  }

  function addEventToLipShadeFinderLabel() {
    window.foundationShadeFinderV1.selectedFoundation.selectors.lipShadeFinderELement.addEventListener(
      'click',
      function () {
        window.foundationShadeFinderV1.selectedFoundation.dialog.closeDialogWithoutOverlay();
      }
    );
  }

  function addEventsToProductMatches() {
    document
      .querySelectorAll('.foundation-shade-finder__dialog2 .foundation-shade-finder__shade-match')
      .forEach(function (p) {
        p.addEventListener('click', function () {
          var shadeMatchLookElement = p.querySelector('.foundation-shade-finder__shade-match-look');
          var shadeMatchLookCheckELement = p.querySelector(
            '.foundation-shade-finder__shade-match-look-check'
          );

          if (shadeMatchLookElement.style.display === 'block') {
            shadeMatchLookElement.style.display = 'none';
            shadeMatchLookCheckELement.style.display = 'block';
            p.classList.add('foundation-shade-finder__shade-match-look-border');

            window.foundationShadeFinderV1.selectedMatches.push(
              shadeMatchLookCheckELement.dataset.skuBaseId
            );
          } else {
            shadeMatchLookElement.style.display = 'block';
            shadeMatchLookCheckELement.style.display = 'none';
            p.classList.remove('foundation-shade-finder__shade-match-look-border');
            var index = window.foundationShadeFinderV1.selectedMatches.indexOf(
              shadeMatchLookCheckELement.dataset.skuBaseId
            );

            if (index > -1) {
              window.foundationShadeFinderV1.selectedMatches.splice(index, 1);
            }
          }
          changeStateOfAddToBagButton();
        });
      });

    document
      .querySelectorAll(
        '.foundation-shade-finder__dialog2 .foundation-shade-finder__shade-match-product-container'
      )
      .forEach(function (p) {
        p.addEventListener('mouseenter', function () {
          p.querySelector('.foundation-shade-finder__onhover-match-view').setAttribute(
            'style',
            'display: block;'
          );
          p.querySelector('.foundation-shade-finder__initial-match-view').setAttribute(
            'style',
            'display: none;'
          );
        });

        p.addEventListener('mouseleave', function () {
          p.querySelector('.foundation-shade-finder__onhover-match-view').setAttribute(
            'style',
            'display: none;'
          );
          p.querySelector('.foundation-shade-finder__initial-match-view').setAttribute(
            'style',
            'display: block;'
          );
        });
      });
  }

  function clearSelectedMatches() {
    window.foundationShadeFinderV1.selectedMatches = [];
  }

  function changeStateOfAddToBagButton() {
    if (window.foundationShadeFinderV1.selectedMatches.length > 0) {
      window.foundationShadeFinderV1.selectedFoundation.selectors.addToBagButton.disabled = false;
    } else {
      window.foundationShadeFinderV1.selectedFoundation.selectors.addToBagButton.disabled = true;
    }
  }

  function addEventToAddToBagButton() {
    window.foundationShadeFinderV1.selectedFoundation.selectors.addToBagButton.addEventListener(
      'click',
      function () {
        var signedIn = parseInt(site.userInfoCookie.getValue('signed_in'));
        var isLoyaltyMember = parseInt(site.userInfoCookie.getValue('is_loyalty_member'));
        var siteUrlLoyalty = window.location.href;
        var validLoyalty = 'even-better-shade-match-science';
        var paramObj = {
          offer_code: 'lyl_shade_match_science',
          do_not_defer_messages: 1
        };
        window.foundationShadeFinderV1.selectedMatches.forEach(function (p) {
          site.addToCart({
            skuData: { SKU_BASE_ID: p },
            qty: 1
          });
        });
        // if the user is signed in and a loyalty member apply the Foundation shade finder offer
        if (signedIn && isLoyaltyMember && siteUrlLoyalty.indexOf(validLoyalty) !== -1) {
          generic.jsonrpc.fetch({
            method: 'offers.apply',
            params: [paramObj]
          });
        }
        clearSelectedMatches();
      }
    );
  }

  function addEventToFoundationShadeFinderCTAs() {
    document.querySelectorAll('.foundation-shade-finder-panel-action').forEach(function (p) {
      p.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        window.foundationShadeFinderV1.openSelectFoundationDialog();
      });
    });
  }

  hookFoundationShadeFinderDialogs();
  addEventToFoundationShadeFinderCTAs();
})();
